/**
 * @file index.tsx
 * @module app/modules/sales-management/admin/index
 * @description Implements the index interface for sales-management operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import Dashboard from './dashboard/dashboard';
import Notifications from './notifications';
import Reports from './reports/reports';
import TargetManagement from './target-management/target-management';
import UserManagement from './user-management/user-management';
import UserDetails from './user-management/user-details';
import CustomerAssignment from './user-management/customer-assignment';
import Orders from './orders/orders';
import { PageLink, PageTitle } from '../../../../_admin/layout/core';
const salesManagementAdminBreadCrumbs: Array<PageLink> = [
  {
    title: 'Sales Management',
    path: '/sales-management',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Admin',
    path: '/sales-management/admin',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const salesManagementAdminUserManagementBreadCrumbs: Array<PageLink> = [
  {
    title: 'Sales Management',
    path: '/sales-management',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Admin',
    path: '/sales-management/admin',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'User Management',
    path: '/sales-management/admin/user-management',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const SalesManagementAdminIndex = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            index
            element={<Navigate to="sales-management/admin/dashboard" />}
          />
          <Route
            path="dashboard"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminBreadCrumbs}>
                  Dashboard
                </PageTitle>
                <Dashboard />
              </>
            }
          />
          <Route
            path="user-management"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminUserManagementBreadCrumbs}>
                  User Management
                </PageTitle>
                <UserManagement />
              </>
            }
          />
          <Route
            path="user-management/user-details"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminUserManagementBreadCrumbs}>
                  User Details
                </PageTitle>
                <UserDetails />
              </>
            }
          />
          <Route
            path="user-management/customer-assignment"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminUserManagementBreadCrumbs}>
                  Customer Assignment
                </PageTitle>
                <CustomerAssignment />
              </>
            }
          />
          <Route
            path="target-management"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminBreadCrumbs}>
                  Target Management
                </PageTitle>
                <TargetManagement />
              </>
            }
          />
          <Route
            path="orders"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminBreadCrumbs}>
                  Orders
                </PageTitle>
                <Orders />
              </>
            }
          />
          <Route
            path="reports"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminBreadCrumbs}>
                  Reports
                </PageTitle>
                <Reports />
              </>
            }
          />
          <Route
            path="notifications"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminBreadCrumbs}>
                  Notifications
                </PageTitle>
                <Notifications />
              </>
            }
          />
          <Route
            path="report-and-performance"
            element={
              <>
                <PageTitle breadcrumbs={salesManagementAdminBreadCrumbs}>
                  Report and Performance
                </PageTitle>
                <Reports />
              </>
            }
          />
          <Route path="*" element={<Navigate to="/error/404" />} />
        </Route>
      </Routes>
    </>
  );
};
export default SalesManagementAdminIndex;
